module.exports = __webpack_public_path__ + "static/media/mojave-night.a5607c44.jpg";